export default "__VITE_ASSET__ff844e50__"